import React, { useState, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";

import './ShowUsers.css'
import './Loader.css'
import { BASE_URL, USER_READ_SCOPE } from './utils/constants';

const ShowUsers = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showTriangle, setShowTriangle] = useState(false);
    const [loadingRoles, setLoadingRoles] = useState([]);
    const { instance } = useMsal();
    const [roles, setRoles] = useState([]);


    useEffect(() => {
        populateData();        
    }, []);


    const handleDelete = async (userId, index) => {
        // Call the API to delete the user
        const apiResponse = await deleteUserFromBackend(userId);

        if (apiResponse.ok) {
            // Remove the user from local state
            const updatedUsers = [...users];
            updatedUsers.splice(index, 1);
            setUsers(updatedUsers);

            const updatedRoles = [...roles];
            updatedRoles.splice(index, 1);
            setRoles(updatedRoles);
        } else {
            console.error('Error deleting the user');
        }
    };

    const deleteUserFromBackend = async (userId) => {
        const accounts = instance.getAllAccounts();
        const request = {
            scopes: [`${USER_READ_SCOPE}`],
            account: accounts[0]
        };
        const response = await instance.acquireTokenSilent(request);
        const accessToken = response.accessToken;

        try {
            return await fetch(`${BASE_URL}/UserManagement/DeleteUser/${userId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
        } catch (error) {
            console.error('Failed to delete the user:', error);
            return { ok: false };
        }
    };
    

    const renderTable = (userData) => {
        return (
            <table className="styled-table">
                <thead>
                    <tr>
                        <th>Display Name</th>                        
                        <th>Issuer Assigned Id</th>
                        <th>Email Hash</th>
                        <th>Other email</th>
                        <th>Other email hash</th>
                        <th>User Role</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {userData.map((user, index) => (
                        <tr key={index}>
                            <td>{user.displayName}</td>                            
                            <td>{user.identities[0]?.issuerAssignedId || 'N/A'}</td>
                            <td>{user.emailHash || 'Fetching...'}</td>
                            <td>{user.otherMails[0] || 'N/A'}</td>
                            <td>{user.otherEmailHash || 'Fetching...'}</td>
                            <td>
                                <div className="cell-container">
                                    <div className={`loader ${loadingRoles[index] ? '' : 'hidden'}`}></div>
                                    <select value={roles[index]} onChange={(e) => handleRoleChange(e, index)} className={loadingRoles[index] ? 'select hidden' : 'select'}>
                                        <option value="Admin">Admin</option>
                                        <option value="User">User</option>
                                    </select>
                                </div>
                            </td>
                            <td>
                                <button onClick={() => handleDelete(user.id, index)}>Delete</button>
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };




    const handleRoleChange = async (event, index) => {
        setLoadingRoles(prevLoadingRoles => {
            const newLoadingRoles = [...prevLoadingRoles];
            newLoadingRoles[index] = true;
            return newLoadingRoles;
        });

        console.log("Turning on loader");

        const newRoles = [...roles];
        newRoles[index] = event.target.value;
        setRoles(newRoles);

        const userToUpdate = users[index];

        const requestBody = {
            id: userToUpdate.id,
            name: "Value won't be used",
            surname: "Value won't be used",
            password: "Value won't be used",
            organization: "Mind",
            email: "Value won't be used",
            role: event.target.value // the new role value from dropdown
        };

        console.log("User:");
        console.log(requestBody);

        const accounts = instance.getAllAccounts();
        const request = {
            scopes: [`${USER_READ_SCOPE}`],
            account: accounts[0]
        };
        const response = await instance.acquireTokenSilent(request);
        const accessToken = response.accessToken;
        console.log('Access token:', accessToken);

        try {
            const apiResponse = await fetch(`${BASE_URL}/UserManagement/UpgradeUser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify(requestBody) // stringify the user object
            });

            if (apiResponse.ok) {
                console.log('User role updated successfully');
            } else {
                console.log('Error updating user role');
            }
        } catch (error) {
            console.log('Error:', error);
        } finally {
            setLoadingRoles(prevLoadingRoles => {
                const newLoadingRoles = [...prevLoadingRoles];
                newLoadingRoles[index] = false;
                return newLoadingRoles;
            });

            console.log("Turning off loader");
        }
    };





   
    const populateData = async () => {
        try {
            const accounts = instance.getAllAccounts();
            if (accounts.length > 0) {
                console.log('Accounts:', accounts);

                const request = {
                    scopes: [`${USER_READ_SCOPE}`],
                    account: accounts[0]
                };

                console.log('Request:', request);

                const response = await instance.acquireTokenSilent(request);
                console.log('Response:', response);

                const accessToken = response.accessToken;
                console.log('Access token:', accessToken);
                
                const apiResponse = await fetch(`${BASE_URL}/UserManagement/AllUsers`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                let users = await apiResponse.json();

                // Fetch email hash for each user and enhance user data
                const usersWithHash = await Promise.all(users.map(async (user) => {
                    const email = user.identities[0]?.issuerAssignedId || '';
                    const otherEmail = user.otherMails[0] || '';
                    if (email) {
                        try {
                            const hashResponse = await fetch(`${BASE_URL}/api/SASToken/GetUserEmailHash/${email}`, {
                                headers: {
                                    'Authorization': `Bearer ${accessToken}`
                                }
                            });
                            const hashData = await hashResponse.text();
                            user.emailHash = hashData;
                        } catch (error) {
                            console.error('Error fetching email hash:', error);
                            user.emailHash = 'Error fetching hash'; // Handle errors or failed requests
                        }
                    } else {
                        user.emailHash = 'N/A'; // Handle cases where email is not available
                    }

                    if (otherEmail) {
                        try {
                            const hashResponse = await fetch(`${BASE_URL}/api/SASToken/GetUserEmailHash/${otherEmail}`, {
                                headers: {
                                    'Authorization': `Bearer ${accessToken}`
                                }
                            });
                            const hashData = await hashResponse.text();
                            user.otherEmailHash = hashData;
                        } catch (error) {
                            console.error('Error fetching email hash:', error);
                            user.otherEmailHash = 'Error fetching hash'; // Handle errors or failed requests
                        }
                    } else {
                        user.otherEmailHash = 'N/A'; // Handle cases where email is not available
                    }
                    return user;
                }));

                setUsers(usersWithHash);
                if (usersWithHash.length > 0) {
                    setRoles(usersWithHash.map(user => user.userRole || 'User'));
                    setLoadingRoles(new Array(usersWithHash.length).fill(false));
                }
                setLoading(false);
            } else {
                console.log('No accounts found');
            }
        } catch (error) {
            console.log('Error:', error);
        }
    };





    return (
        <div className="show-users-container">
            {loading ? (
                <div className="loading-container">
                    <div className="spinner"></div>
                </div>
            ) : users.length > 0 ? (
                <div className="table-container">
                    {renderTable(users)}
                </div>
            ) : (
                <p><em>Access unauthorized. Please request account clearance.</em></p>
            )}
        </div>
    );

};

export default ShowUsers;
